module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect",
    class: {
      'multiselect--active': _vm.isOpen, 'multiselect--disabled': _vm.disabled, 'multiselect--above': _vm.isAbove
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex
    },
    on: {
      "focus": function($event) {
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      }
    }
  }, [_vm._t("caret", [_c('div', {
    staticClass: "multiselect__select",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle()
      }
    }
  })], {
    toggle: _vm.toggle
  }), _vm._v(" "), _vm._t("clear", null, {
    search: _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "multiselect__tags"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValue.length > 0),
      expression: "visibleValue.length > 0"
    }],
    staticClass: "multiselect__tags-wrap"
  }, [_vm._l((_vm.visibleValue), function(option) {
    return [_vm._t("tag", [_c('span', {
      staticClass: "multiselect__tag"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "multiselect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_c('strong', {
    staticClass: "multiselect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "multiselect__spinner"
  })])], 2), _vm._v(" "), (_vm.searchable) ? _c('input', {
    ref: "search",
    staticClass: "multiselect__input",
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.isOpen ? _vm.search : _vm.currentOptionLabel
    },
    on: {
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.deactivate()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.searchable) ? _c('span', {
    staticClass: "multiselect__single",
    domProps: {
      "textContent": _vm._s(_vm.currentOptionLabel)
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "multiselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "multiselect__content",
    style: (_vm.contentStyle)
  }, [_vm._t("beforeList"), _vm._v(" "), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected option to select another.")])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "multiselect__element"
    }, [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "touchstart": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.handleTouchStartStop(index, option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "multiselect__option multiselect__option--disabled",
      class: _vm.optionHighlight(index, option)
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),
      expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noResult", [_vm._v("No elements found. Consider changing the search query.")])], 2)]), _vm._v(" "), _vm._t("afterList")], 2)])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-397df2d7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-397df2d7"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!/home/alarmplan/staging/shared/frontend/~/vue-multiselect/src/Multiselect.vue
// module id = 1028
// module chunks = 0